const scoreTable = {
    /*I-1高校生以上用換算表
    **粗点:換算点
    **検査3形態照合検査
    */
    scoreTable3: {
        36:117,
        35:114,
        34:110,
        33:106,
        32:102,
        31:99,

        30:95,
        29:91,
        28:88,
        27:84,
        26:80,

        25:76,
        24:73,
        23:69,
        22:65,
        21:62,

        20:58,
        19:54,
        18:51,
        17:47,
        16:43,

        15:39,
        14:36,
        13:32,
        12:28,
        11:25,

        10:21,
        9:17,
        8:14,
        7:10,
        6:6,

        5:2,
        4:0,
        3:-4,
        2:-8,
        1:-11,
        0:-15,
        },
        
        /*I-1高校生以上用換算表
        **粗点:換算点
        **検査4名詞比較検査
        */
        scoreTable4:{
            70:198, 
            69:194, 
            68:191, 
            67:187, 
            66:184, 
            
            65:180, 
            64:177, 
            63:173, 
            62:170, 
            61:166, 
            
            60:163, 
            59:159, 
            58:156, 
            57:152, 
            56:149, 
            
            55:145, 
            54:142, 
            53:138, 
            52:135, 
            51:131, 
            
            50:127, 
            49:124, 
            48:120, 
            47:117, 
            46:113, 
            
            45:110, 
            44:106,
            43:103,
            42:99, 
            41:96,
            
            40:92, 
            39:89, 
            38:85,
            37:82, 
            36:78, 
            
            35:75, 
            34:71, 
            33:68, 
            32:64, 
            31:61, 
            
            30:57, 
            29:54,
            28:50,
            27:47,
            26:43,
            
            25:40,
            24:36,
            23:32,
            22:29,
            21:25,
            
            20:22,
            19:18,
            18:15,
            17:11,
            16:8,
            
            15:4,
            14:1,
            13:-2, 
            12:-5,
            11:-9,
            
            10:-12,
            9:-16,
            8:-19,
            7:-23,
            6:-26,
            
            5:-30,
            4:-33,
            3:-37,
            2:-40,
            1:-44,
            0:-47,
        },
        
        /*I-1高校生以上用換算表
        **粗点:換算点
        **検査5図柄照合検査
        */
        scoreTable5:{
            24:92,
            23:86,
            22:80,
            21:74,
            
            20:68,
            19:63,
            18:57,
            17:51,
            16:45,
            
            15:39,
            14:33,
            13:27,
            12:21,
            11:15,
            
            10:10,
            9:4,
            8:-1,
            7:-7,
            6:-13,
            
            5:-19,
            4:-25,
            3:-31,
            2:-37,
            1:-42,
            0:-48,
        },
        
        /*I-1高校生以上用換算表
        **粗点:換算点
        **検査6平面図判断検査
        */
        scoreTable6:{
            24:119,
            23:114,
            22:108,
            21:103,
            20:97,
            19:92,
            18:87,
            17:81,
            16:76,
            15:70,
            14:65,
            13:60,
            12:54,
            11:49,
            10:44,
            9:38,
            8:33,
            7:27,
            6:22,
            5:17,
            4:11,
            3:6,
            2:1,
            1:-4,
            0:-9
        },
        
        /*I-1高校生以上用換算表
        **粗点:換算点
        **検査7計算検査
        */
        scoreTable7:{
            30:109,
            29:105,
            28:101,
            27:97,
            26:93,
            
            25:89,
            24:85,
            23:81,
            22:77,
            21:73,
            
            20:69,
            19:65,
            18:61,
            17:56,
            16:52,
            
            15:48,
            14:44,
            13:40,
            12:36,
            11:32,
            
            10:28,
            9:24,
            8:20,
            7:16,
            6:12,
            
            5:8,
            4:4,
            3:0,
            2:-3,
            1:-7,
            0:-11
        },
        
        /*I-1高校生以上用換算表
        **粗点:換算点
        **検査8語意検査
        */
        scoreTable8:{
            40:132,
            39:128,
            38:125,
            37:122,
            36:119,
            
            35:115,
            34:112,
            33:109,
            32:106,
            31:103,
            
            30:99,
            29:96,
            28:93,
            27:90,
            26:86,
            
            25:83,
            24:80,
            23:77,
            22:74,
            21:70,
            
            20:67,
            19:64,
            18:61,
            17:57,
            16:54,
            
            15:51,
            14:48,
            13:45,
            12:41,
            11:38,
            
            10:35,
            9:32,
            8:28,
            7:25,
            6:22,
            
            5:19,
            4:16,
            3:12,
            2:9,
            1:6,
            0:3,
        },
        
        /*I-1高校生以上用換算表
        **粗点:[換算点G(知的), 換算点S(空間)]
        **検査9立体図判断検査
        */
        scoreTable9:{
        28:[61,89],
        27:[58,85],
        26:[55,81],
        
        25:[53,78],
        24:[50,74],
        23:[47,70],
        22:[45,67],
        21:[42,63],
        
        20:[39,59],
        19:[37,56],
        18:[34,52],
        17:[31,49],
        16:[29,45],
        
        15:[26,41],
        14:[23,48],
        13:[21,34],
        12:[18,30],
        11:[15,27],
        
        10:[13,23],
        9:[10,20],
        8:[7,16],
        7:[4,12],
        6:[2,9],
        
        5:[0,5],
        4:[-3,1],
        3:[-5,-1],
        2:[-8,-5],
        1:[-11,-9],
        0:[-13,-12]
        },
        
        /*I-1高校生以上用換算表
        **粗点:[換算点G(知的), 換算点V(言語)]
        **検査10文章完成険査
        */
        scoreTable10:{
        48:[73,66],
        47:[72,65],
        46:[70,64],
        
        45:[68,62],
        44:[66,61],
        43:[65,60],
        42:[63,58],
        41:[61,57],
        
        40:[60,55],
        39:[58,54],
        38:[56,53],
        37:[54,51],
        36:[53,50],
        
        35:[51,49],
        34:[49,47],
        33:[48,46],
        32:[46,45],
        31:[44,43],
        
        30:[42,42],
        29:[41,41],
        28:[39,39],
        27:[37,38],
        26:[36,36],
        
        25:[34,35],
        24:[32,34],
        23:[30,32],
        22:[29,31],
        21:[27,30],
        
        20:[25,28],
        19:[23,27],
        18:[22,26],
        17:[20,24],
        16:[18,23],
        
        15:[17,22],
        14:[15,20],
        13:[13,19],
        12:[11,17],
        11:[10,16],
        
        10:[8,15],
        9:[6,13],
        8:[5,12],
        7:[3,11],
        6:[1,9],
        
        5:[0,8],
        4:[-1,7],
        3:[-3,5],
        2:[-5,4],
        1:[-6,3],
        0:[-8,1]
        },
        
        /*I-1高校生以上用換算表
        **粗点:[換算点G(知的), 換算点N(数理)]
        **検査11算数応用検査
        */
        scoreTable11:{
        20:[84,87],
        19:[79,83],
        18:[75,79],
        17:[71,75],
        16:[67,71],
        
        15:[63,67],
        14:[58,63],
        13:[54,59],
        12:[50,55],
        11:[46,51],
        
        10:[42,47],
        9:[38,43],
        8:[33,38],
        7:[29,34],
        6:[25,30],
        
        5:[21,26],
        4:[17,22],
        3:[13,18],
        2:[8,14],
        1:[4,10],
        0:[0,6]
        },
    };
    
export default scoreTable;